import { useEffect, useState } from "react";
import AdminService from "../AdminService";
import { useAdminAuth } from "../AdminAuthContext";

export function useCustomers() {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const { userInfo, userRoles } = useAdminAuth();
    console.log('userRoles', userRoles);
    const fetchCustomers = async () => {
        try {
            setLoading(true);
            setError(null);

            const res = await AdminService.getManageCustomers();
            console.log('res', res);
            setData(res?.data || []);
        } catch (err) {
            console.error("Customers API Error", err);
            setError(err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchCustomers();
    }, []);

    return { data, loading, error, refetch: fetchCustomers };
}